/* eslint-disable max-len */
import {
	all, call, put, takeEvery,
} from "redux-saga/effects";
import Env from "Consts/env";
import { handle498OnClient } from "Helpers/is498";
import {
	ActionsCartTotal,
	failureCartTotal,
	loadCartTotalSuccess,
	loadGetCartTotal,
	API_CART_TOTAL,
} from "./actions";

// Function Fetch CartTotal
function* loadDataCartTotal() {

	try {

		yield put(loadGetCartTotal());

		const endpoint = API_CART_TOTAL;
		const headers = { ...Env.HEADERS };
		const method = "GET";
		const options = { headers, method };

		const response = yield call(fetch, endpoint, options);
		if (
			typeof response.status !== "undefined"
			&& response.status >= 200
			&& response.status < 300
		) {

			const self = yield response.json();

			yield all([
				put(handle498OnClient(self)),
				put(loadCartTotalSuccess(self)),
			]);

		} else {

			throw response;

		}

	} catch (err) {

		yield put(failureCartTotal(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsCartTotal.GET_CART_TOTAL, loadDataCartTotal);

}
